import type { Active, Over } from "@dnd-kit/core";

import type { DragData, SpaceDragData, SpaceGroupDragData } from "./types";

const isDragData = (data: unknown): data is DragData => {
  if (typeof data !== "object" || data === null) return false;
  if (!("type" in data) || !("id" in data)) return false;
  return (
    (data.type === "space" &&
      "spaceGroupId" in data &&
      typeof data.id === "number" &&
      typeof data.spaceGroupId === "number") ||
    (data.type === "spaceGroup" && typeof data.id === "number")
  );
};

export const isSpaceDragData = (data: DragData): data is SpaceDragData =>
  data.type === "space";

export const isSpaceGroupDragData = (
  data: DragData,
): data is SpaceGroupDragData => data.type === "spaceGroup";

export const getDragData = (item: Active | Over): DragData | null => {
  const data = item.data.current;
  return isDragData(data) ? data : null;
};
